import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'
import { useIntl } from 'react-intl'
import IconButton from './IconButton'
import ButtonGroup from './ButtonGroup'

export type SaveCancelButtonGroupProps = {
	onSaveClick: () => void
	onCancelClick: () => void
	className?: string
}

const SaveCancelButtonGroup = ({
	onSaveClick,
	onCancelClick,
	className,
}: SaveCancelButtonGroupProps) => {
	const { formatMessage } = useIntl()

	return (
		<ButtonGroup
			className={className}
			overflowLimit={2}
			items={[
				<IconButton
					key="save-button"
					onClick={onSaveClick}
					tooltipTitle={formatMessage({ id: 'global.save' })}
					color="primary"
				>
					<CheckIcon />
				</IconButton>,
				<IconButton
					key="cancel-button"
					onClick={onCancelClick}
					tooltipTitle={formatMessage({ id: 'remove_record.cancel' })}
					color="error"
				>
					<CloseIcon />
				</IconButton>,
			]}
		/>
	)
}

export default SaveCancelButtonGroup
